import React from "react";
import "../assets/css/style.css";
import LeftGnb from "../components/leftGnb";
import RedirectItems from "../components/redirectItems";
import GnbTop from "../components/gnb_top";

const Main = () => {
    return (
        <>
            <div className="main_wrapper">
                <LeftGnb />
                <GnbTop />
                <RedirectItems />
            </div>
        </>
    );
};

export default Main;
